import React, { forwardRef, useImperativeHandle, useState } from "react";
import CardLayout from "../common/CardLayout";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import CategoryDetails from "../categoryDetails/CategoryDetails";

export default forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        setItems: setItems,
        hide: hide,
        show: show
    }));

    const [variantCategorySummary, setVariantCategorySummary] = useState([]);
    const [currentCategorySummary, setCurrentCategorySummary] = useState([]);
    const [expenseType, setExpenseType] = useState("current");
    const [visible, setVisible] = useState(true);

    const currentExpensesClickCallback = () => {
        setExpenseType("current");
    };

    const variableExpensesClickCallback = () => {
        setExpenseType("variable");
    };

    const hide = () => {
        setVisible(false);
    };

    const show = () => {
        setVisible(true);
    };

    const setItems = ({ variantCategorySummary, currentCategorySummary }) => {
        setVariantCategorySummary(variantCategorySummary);
        setCurrentCategorySummary(currentCategorySummary);
    };

    return visible ? (
        <CardLayout header={"פירוט הוצאות"}>
            <div style={{ position: "absolute", zIndex: 500 }}>
                <ButtonGroup style={{ margin: "10px" }}>
                    <ToggleButton
                        style={{ marginRight: "10px" }}
                        key={1}
                        id={`radio-${1}`}
                        type="radio"
                        variant={"outline-secondary"}
                        value={"variable"}
                        checked={expenseType === "variable"}
                        onClick={variableExpensesClickCallback}
                        onChange={(e) => setExpenseType(e.currentTarget.value)}
                    >
                        משתנות
                    </ToggleButton>
                    <ToggleButton
                        style={{ marginRight: "10px" }}
                        key={0}
                        id={`radio-${0}`}
                        type="radio"
                        variant={"outline-secondary"}
                        value={"current"}
                        checked={expenseType === "current"}
                        onClick={currentExpensesClickCallback}
                        onChange={(e) => setExpenseType(e.currentTarget.value)}
                    >
                        שוטפות
                    </ToggleButton>
                </ButtonGroup>
            </div>
            {expenseType === "current" && (
                <CategoryDetails
                    height={310}
                    items={currentCategorySummary}
                    categoryWasClicked={props.currentCategoryWasClicked}
                />
            )}
            {expenseType === "variable" && (
                <CategoryDetails
                    height={310}
                    items={variantCategorySummary}
                    categoryWasClicked={props.variantCategoryWasClicked}
                />
            )}
        </CardLayout>
    ) : (
        <div />
    );
});
